import React from "react";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import { Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import Button from "../../elements/Button";
import classes from "./EmptyCampaignTemplatesPage.module.scss";
import { ROUTE_PATHS } from "../../../types/RoutePaths";

const EmptyCampaignTemplatesPage = () => {
  const history = useHistory();

  return (
    <div className={classes.emptyPageContainer}>
      <div className={classes.iconContainer}>
        <SentimentVeryDissatisfiedIcon className={classes.sadIcon} />
        <Typography variant="h4" className={classes.title}>
          It's empty here
        </Typography>
      </div>
      <Typography variant="h6" color="textSecondary" gutterBottom>
        Templates help you speed up campaign creation. Create your first template now.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => history.push(ROUTE_PATHS.CREATE_CAMPAIGN_TEMPLATE)}>
        Create Template
      </Button>
    </div>
  );
};

export default EmptyCampaignTemplatesPage;
